import React from 'react';
import { Field } from 'formik';

import styles from './expertiseFormStyles';

import CheckboxesField from 'buyside/components/presentation/Form/Field/CheckboxesField/checkboxesField';

const {
  sectorNames,
  geographyNames,
  assetClassNames
} = require('buyside/util/constantsFromRails.json');

const ExpertiseForm = () => {
  return (
    <div>
      <div className={styles.expertiseFormSection}>
        <h4 className={styles.expertiseFormSectionTitle}>Sector</h4>
        <Field
          component={CheckboxesField}
          name="userProfile.sectorExpertise"
          options={sectorNames}
          numColumns={3}
        />
      </div>
      <div className={styles.expertiseFormSection}>
        <h4 className={styles.expertiseFormSectionTitle}>Geographic</h4>
        <Field
          component={CheckboxesField}
          name="userProfile.geographicExpertise"
          options={geographyNames}
          numColumns={3}
        />
      </div>
      <div className={styles.expertiseFormSection}>
        <h4 className={styles.expertiseFormSectionTitle}>Asset Class</h4>
        <Field
          component={CheckboxesField}
          name="userProfile.assetClassExpertise"
          options={assetClassNames}
          numColumns={3}
        />
      </div>
    </div>
  );
};

export default ExpertiseForm;
